import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { clearLocalStorage } from '../../helper/storage'
import { axiosInstance } from '../../axios/interceptor'

export const addClient = createAsyncThunk('client/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/admin/client/register-ghost`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editClient = createAsyncThunk('client/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/admin/client/update-client/${data?.client_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deleteClient = createAsyncThunk('client/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/admin/client/delete-client/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllClient = createAsyncThunk('client/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/client/get-all-clients`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getClientByID = createAsyncThunk('client/get', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/properties/get-properties/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getClienInfo = createAsyncThunk('client/getInfo', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/client/get-client/${id}`, { skipErrorToast: true })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const updateClientStatus = createAsyncThunk('client/update-status', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/admin/client/update-client-status/${data?.client_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addStrike = createAsyncThunk('client/strike', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/client-strike/create-client-strike`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getUpcomingCleaning = createAsyncThunk('client/upcoming-cleaning', async (data, { rejectWithValue }) => {
  const params = data.params
  try {
    const response = await axiosInstance.get(`/property-schedule/get-upcoming-schedules/${data?.client_id}`, { params, skipErrorToast: true })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllClientsReviews = createAsyncThunk('client/review', async (data, { rejectWithValue }) => {
  const params = data.params
  try {
    const response = await axiosInstance.get(`cleaning-review/get-cleaning-reviews-by-client/${data?.id}`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const updateInvoicePayment = createAsyncThunk('admin/client/update-invoice-payment', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`admin/client/update-invoice-payment/${data?.id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getClientHistory = createAsyncThunk('client/history', async (data, { rejectWithValue }) => {
  const params = data.params
  try {
    const response = await axiosInstance.get(`/property-schedule/past-schedules/${data?.id}`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getGoogleMapUrl = createAsyncThunk('client/google-map-url/get', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/get-google-map-url/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allClient: [],
  getClient: null,
  clientInfo: {},
  allUpcomingCleaning: [],
  clientReviews: [],
  clientHistoryData: [],
  client: null,
  error: null
}

const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    resetAuthState: (state) => {
      state.user = null
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addClient.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addClient.fulfilled, (state, action) => {
        state.isLoading = false
        state.client = action.payload?.data?.data
      })
      .addCase(addClient.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editClient.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editClient.fulfilled, (state, action) => {
        state.isLoading = false
        state.client = action.payload?.data?.data
      })
      .addCase(editClient.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(deleteClient.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteClient.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deleteClient.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllClient.pending, (state) => {
        state.isLoading = true
        state.allClient = []
      })
      .addCase(getAllClient.fulfilled, (state, action) => {
        state.isLoading = false
        state.allClient = action.payload?.data?.data
      })
      .addCase(getAllClient.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getClientByID.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getClientByID.fulfilled, (state, action) => {
        state.isLoading = false
        state.getClient = action.payload?.data?.data
      })
      .addCase(getClientByID.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getClienInfo.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getClienInfo.fulfilled, (state, action) => {
        state.isLoading = false
        state.clientInfo = action.payload?.data?.data
      })
      .addCase(getClienInfo.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(updateClientStatus.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateClientStatus.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(updateClientStatus.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(addStrike.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addStrike.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(addStrike.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getUpcomingCleaning.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getUpcomingCleaning.fulfilled, (state, action) => {
        state.isLoading = false
        state.allUpcomingCleaning = action?.payload?.data?.data
      })
      .addCase(getUpcomingCleaning.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllClientsReviews.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllClientsReviews.fulfilled, (state, action) => {
        state.isLoading = false
        state.clientReviews = action?.payload?.data?.data
      })
      .addCase(getAllClientsReviews.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
        state.clientReviews = []
      })
      .addCase(updateInvoicePayment.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateInvoicePayment.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(updateInvoicePayment.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getClientHistory.pending, (state) => {
        state.isLoading = true
        state.clientHistoryData = []
      })
      .addCase(getClientHistory.fulfilled, (state, action) => {
        state.isLoading = false
        state.clientHistoryData = action?.payload?.data?.data
      })
      .addCase(getClientHistory.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getGoogleMapUrl.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getGoogleMapUrl.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(getGoogleMapUrl.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetAuthState } = clientSlice.actions
export default clientSlice.reducer
